import React, { useRef, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Input from '@material-ui/core/Input'

const useStyles = makeStyles(theme => ({
  input: {
    width: '100%',
  }
}))

const NameEditor = ({
  value,
  onChange,
  onCommit,
  onReset,
}) => {

  const classes = useStyles()
  const inputRef = useRef()
  const [ startingValue, setStartingValue ] = useState('')

  useEffect(() => {
    inputRef.current.click()
    setStartingValue(value)
  }, [])

  const getInput = () => {
    return inputRef.current.querySelector('input')
  }

  const commit = () => {
    if(value == startingValue) {
      onReset()
    }
    else {
      onCommit()
    }
  }

  return (
    <Input
      className={ classes.input }
      value={ value }
      ref={ inputRef }
      onKeyDown={ (e) => {
        if (e.key === "Enter") {
          e.preventDefault()
          commit()
        }
        else if(e.key === "Escape") {
          e.preventDefault()
          onReset()
        }
      }}
      onChange={ (e) => onChange(e.target.value) }
      onBlur={ () => commit() }
      onFocus={ () => {
        getInput().select()
      }}
    />
  )
}

export default NameEditor

